export default __webpack_public_path__ + "static/media/our-growing-msg-mobile.62a31a97.svg";